import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';

import { MgAvatarModule } from '@app/src/app/elements/MgAvatar';
import { MgShortCardModule } from '@app/src/app/elements/MgShortCard';

import { MgBirthdayShortCardElement } from './MgBirthdayShortCard.element';

@NgModule({
  imports: [
    // Minga dependencies
    MgAvatarModule,
    MgShortCardModule,

    // External dependencies
    CommonModule,
  ],
  declarations: [MgBirthdayShortCardElement],
  exports: [MgBirthdayShortCardElement],
})
export class MgBirthdayShortCardModule {
  constructor(injector: Injector) {
    if (!customElements.get('minga-birthday-short-card')) {
      //       //   MgBirthdayShortCardElement,
      //   {injector},
      // ));
    }
  }
}
